import { GzSandboxIcapSensorWebComponent } from './component/GzSandboxIcapSensorWebComponent';

export { GzSandboxIcapSensorWebComponent };
